import React from 'react';
import AnchorButton from "./AnchorButton";
import { fetch, redirectTo, isIterable } from "../../modules/utils";
export default function FetchAndRedirectButton({ children, path, method, redirect_path, modifiers = ['block', 'primary'], classes = [] }) { const handleClick = () => { fetch(method, path).then(() => redirectTo(redirect_path)).catch(e => { if (isIterable(e)) {
    const [message] = e;
    console.error('Fetch failed: ' + message);
} }); }; return /*#__PURE__*/ React.createElement(AnchorButton, { children: children, classes: classes, onClick: handleClick, modifiers: modifiers }); }
